<template>
  <div class="culturalPage">
    <div class="act-list">
      <div
        class="carousel"
        @mousedown="startDrag"
        @mouseup="endDrag"
        @mouseleave="endDrag"
      >
        <div class="carousel-slides" ref="slides" @mousemove="drag">
          <div
            class="carousel-slide"
            v-for="slide in culturalData"
            :key="slide.id"
          >
            <img class="pc" v-if="!isIndex" :src="slide.img" alt="" />
            <img class="wap" v-else :src="slide.img" alt="" />
          </div>
        </div>
      </div>
      <div class="carousel-pagination">
        <div
          v-for="(_, index) in culturalData"
          :key="index"
          :class="{
            'carousel-pagination-button': true,
            active: currentIndex === index,
          }"
          @click="goToSlide(index)"
        ></div>
      </div>
      <template v-if="!isIndex">
        <div
          class="work-info"
          v-for="(item, index) in culturalData"
          :key="index"
        >
          <div class="work-title" v-if="currentIndex === index">
            {{ lan ? item.advertEnName : item.advertCnName }}
          </div>
          <div class="work-dec" v-if="currentIndex === index">
            {{ lan ? item.advertEnDesc : item.advertCnDesc }}
          </div>
        </div>
      </template>
    </div>
    <div class="culturalSlider" v-for="item in CulturalSlider" :key="item.id">
      <CulturalSlider :showData="item" :showNumber="item.id" />
    </div>
    <div>
      <div class="foot-title">
        {{ lan ? "Purchasing method" : "购买方式" }}
      </div>
      <div class="grey-line"></div>
      <div class="buy-in-store" @click="showStore = !showStore">
        <div class="store-info">
          <div class="buy-store-title">
            {{ lan ? "In-store Shopping:" : "到店购买" }}
          </div>
          <div class="buy-store-dec">
            {{
              lan
                ? "Gift shop, ChunYangTai Floor, 18 Qingyun Road, Langtou Village, Tanbu Town, Huadu District, Guangzhou"
                : "广州市花都区炭步镇朗头村青云路18号春阳台一层文创商店"
            }}
          </div>
        </div>
        <div class="store-img-box" v-if="showStore">
          <img class="store-img" src="../../assets/rural_store.jpg" alt="" />
        </div>
      </div>
      <div class="grey-line"></div>
      <div class="buy-in-store" @click="showStoreQr = !showStoreQr">
        <div class="store-info">
          <div class="buy-store-title">
            {{ lan ? "Online Shopping:" : "线上购买" }}
          </div>
          <div class="buy-store-dec">
            {{
              lan
                ? "Gift shop on Langtou Village Wechat Mini Program"
                : "塱古村小程序文创商店"
            }}
          </div>
        </div>
        <div class="store-img-box" v-if="showStoreQr">
          <img class="store-img-qr" src="../../assets/rural_qr.jpg" alt="" />
        </div>
      </div>
      <div class="grey-line"></div>
    </div>
  </div>
</template>
<script>
import CulturalSlider from "../components/culturalSlider";
export default {
  name: "culturalPage",
  components: {
    CulturalSlider,
  },
  data() {
    return {
      isIndex: false,
      culturalData: [],
      CulturalSlider: [],
      currentIndex: 0, // 当前显示的轮播图索引
      startX: 0,
      dragging: false,
      threshold: 50, // 滑动阈值，单位为像素
      showStore: true,
      showStoreQr: true,
      lan: this.$store.state.isEn,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  mounted() {
    this.init();
    this.startAutoplay();
    if (this.isIndex) {
      window.addEventListener("touchstart", this.startDrag);
      window.addEventListener("touchmove", this.drag);
      window.addEventListener("touchend", this.endDrag);
    }
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    async init() {
      this.$api.get("/cultural/list", { current: 1, pageSize: 10 }, (r) => {
        const { data, code } = r;
        if (code == 0) {
          if (data && data.length > 0) {
            data.forEach((el) => {
              if (this.lan) {
                el.imgList = (el.imageEn && JSON.parse(el.imageEn)) || "";
              } else {
                el.imgList = (el.imageCn && JSON.parse(el.imageCn)) || "";
              }
            });
            this.CulturalSlider = JSON.parse(JSON.stringify(data));
          }
        }
      });

      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "product_banner" },
        (res) => {
          const { data, code } = res;
          if (code == 0) {
            if (data && data.length > 0) {
              data.forEach((el) => {
                el.img = (el.image && JSON.parse(el.image)[0].src) || "";
              });
              this.culturalData = JSON.parse(JSON.stringify(data));
            }
          }
        }
      );
    },
    startDrag(event) {
      if (event.touches) {
        this.startX = this.isIndex ? event.touches[0].clientX : event.clientX;
      } else {
        this.startX = event.clientX;
      }
      this.dragging = true;
    },
    drag(event) {
      if (!this.dragging) return;
      let deltaX = 0;
      if (this.isIndex) {
        deltaX = event.touches[0].clientX - this.startX;
      } else {
        deltaX = event.clientX - this.startX;
        // 阻止默认滚动行为
        event.preventDefault();
      }
    },
    endDrag(event) {
      if (!this.dragging) return;
      clearInterval(this.autoplayInterval);
      let deltaX = 0;
      if (this.isIndex) {
        deltaX = event.changedTouches[0].clientX - this.startX;
      } else {
        deltaX = event.clientX - this.startX;
      }
      if (Math.abs(deltaX) > this.threshold) {
        if (deltaX > 0) {
          // 右滑，切换到上一张
          this.prevSlide();
        } else {
          // 左滑，切换到下一张
          this.nextSlide();
        }
      }

      this.dragging = false;
      this.startAutoplay(); // 重启自动播放
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.culturalData.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex + this.culturalData.length - 1) %
        this.culturalData.length;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    goToSlide(index) {
      this.currentIndex = index;
      this.$refs.slides.style.transform = `translateX(-${
        100 * this.currentIndex
      }%)`;
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextSlide, 5000); // 每5秒切换一次轮播图
    },
  },
  beforeDestroy() {
    if (this.isIndex) {
      window.removeEventListener("touchstart", this.startDrag);
      window.removeEventListener("touchmove", this.drag);
      window.removeEventListener("touchend", this.endDrag);
    }
    clearInterval(this.autoplayInterval);
  },
};
</script>
<style scoped>
.culturalPage {
  width: 1440px;
  margin: 150px auto 100px;
}
.content-title {
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.title-right-btn {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #98989f;
  text-align: left;
  font-weight: 400;
  padding-right: 15px;
  cursor: pointer;
  margin-bottom: 20px;
}
.act-list {
  position: relative;
  background: #eaeaea;
  margin-bottom: 70px;
}
.title-left {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
  margin: 60px 0 20px;
}
.carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 1046px;
}

.carousel-slides {
  position: relative;
  display: flex;
  width: 1046px; /* 假设有三个轮播项，每个轮播项宽100% */
  transition: transform 0.5s ease;
  color: #000;
}
.carousel-slides .pc {
  width: 1046px;
  height: 640px;
  object-fit: cover;
  z-index: -10;
}

.carousel-slide {
  flex: 0 0 100%;
  min-width: 100%;
  text-align: left;
}

.carousel-slide.active {
  /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
}

.carousel-pagination {
  position: absolute;
  bottom: 40px;
  right: 0;
  width: 360px;
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}

.carousel-pagination-button {
  margin: auto 4px !important;
  opacity: 1;
  width: 20px;
  height: 4px;
  background: url(../../assets/diandian_grey.png) no-repeat center;
  background-size: contain;
  cursor: pointer;
}

.carousel-pagination-button.active {
  width: 20px;
  height: 4px;
  background: none;
  position: relative;
  background: url(../../assets/diandian_highllight.png) no-repeat center;
  background-size: contain;
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #000;
  border: none;
  cursor: pointer;
  z-index: 10;
}
.work-info {
  width: 360px;
  text-align: left;
  position: absolute;
  bottom: 100px;
  right: 0px;
  z-index: 1;
}
.work-title {
  width: 330px;
  font-family: SourceHanSansCN-Bold;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 600;
  margin-bottom: 20px;
}
.work-dec {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #2c2c2c;
  letter-spacing: 0;
  text-align: left;
  line-height: 26px;
  font-weight: 400;
}
.foot-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 600;
  margin: 80px 0 20px;
}
.grey-line {
  width: 1440px;
  height: 1px;
  background: #d8d8d8;
}
.buy-in-store {
  display: flex;
  justify-content: space-between;
}
.store-img {
  margin: 30px 0;
  width: 640px;
  height: 314px;
}
.store-info {
  margin-top: 30px;
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.buy-store-dec {
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  color: #585c64;
  letter-spacing: 0;
  text-align: left;
  font-weight: 500;
  margin: 8px 0 30px;
}
.store-img-qr {
  width: 640px;
  height: 314px;
  margin: 30px 0;
}
@media (max-width: 1440px) {
  .culturalPage {
    width: 100%;
  }
  .act-list {
    margin: 0 auto;
    transform: scale(0.9);
    position: relative;
    background: #eaeaea;
    margin-bottom: 70px;
  }
  .foot-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 600;
    margin: 80px 0 20px 40px;
  }
  .buy-in-store {
    width: 92%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .carousel-slides {
    background-color: transparent;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 946px;
  }

  .carousel-slides {
    position: relative;
    display: flex;
    width: 946px; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides .pc {
    width: 946px;
    height: 560px;
    object-fit: cover;
    z-index: -10;
  }
  .store-img {
    margin: 30px 0;
    width: 80%;
    height: 314px;
  }
  .store-img-qr {
    width: 80%;
    max-width: 90%;
    height: 314px;
    margin: 30px 0;
  }
  .grey-line {
    width: 100%;
    height: 1px;
    background: #d8d8d8;
  }
}
@media (max-width: 1300px) {
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .carousel-slides {
    position: relative;
    display: flex;
    width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides .pc {
    width: 100%;
    height: 500px;
    object-fit: cover;
    z-index: -10;
  }
}
@media (max-width: 960px) {
  .culturalPage {
    width: 100%;
    margin: 80px auto 30px;
  }
  .content-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .title-right-btn {
    position: relative;
    font-family: SourceHanSansCN-Regular;
    font-size: 20px;
    color: #98989f;
    text-align: left;
    font-weight: 400;
    padding-right: 15px;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .culturalSlider {
    width: 92%;
    margin: 0 auto;
  }
  .act-list {
    position: relative;
    background: #eaeaea;
    margin-bottom: 20px;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 26px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
    margin: 40px 0 15px;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .carousel-slides {
    position: relative;
    display: flex;
    width: 100%; /* 假设有三个轮播项，每个轮播项宽100% */
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides .pc {
    display: none;
  }
  .carousel-slides .wap {
    display: block;
    width: 100%;
    min-height: calc(100vw * 0.5);
    max-height: calc(100vh * 0.24);
    object-fit: cover;
    z-index: -10;
  }

  .carousel-slide {
    flex: 0 0 100%;
    min-width: 100%;
    text-align: center;
  }

  .carousel-slide.active {
    /* 实际上，由于我们使用了transform来定位活动轮播项，所以不需要这个类 */
  }

  .carousel-pagination {
    position: absolute;
    bottom: 40px;
    right: 0;
    width: 360px;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .carousel-pagination-button {
    margin: auto 2px !important;
    opacity: 1;
    width: 13px;
    height: 2.6px;
    background: url(../../assets/diandian_grey.png) no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .carousel-pagination-button.active {
    width: 13px;
    height: 2.6px;
    background: none;
    position: relative;
    background: url(../../assets/diandian_highllight.png) no-repeat center;
    background-size: contain;
  }

  .carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: #000;
    border: none;
    cursor: pointer;
    z-index: 10;
  }
  .grey-line {
    width: 92%;
    margin: 20px auto 0;
    height: 1px;
    background: #d8d8d8;
  }
  .foot-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 600;
    width: 90%;
    margin: 30px auto 20px;
  }
  .buy-in-store {
    display: block;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
  }
  .store-img-box {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .store-img {
    margin: 0px auto;
    width: 100%;
    height: auto;
  }
  .store-info {
    margin-top: 30px;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 700;
  }
  .buy-store-dec {
    font-family: SourceHanSansCN-Medium;
    font-size: 12px;
    color: #585c64;
    letter-spacing: 0;
    text-align: left;
    font-weight: 500;
    margin: 8px 0 15px;
  }
  .store-img-qr {
    margin: 0px auto;
    width: 100%;
    height: auto;
    object-fit: cover;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .carousel-pagination {
    position: absolute;
    bottom: 20px;
    right: 0;
    width: 95%;
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;
  }
}
</style>